// src/pages/MergerDashboard/BenefitBuildingsTab.js

import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid
} from 'recharts';

function BenefitBuildingsTab({
  nationA,
  nationB,
  nationInfo,
  isLoadingTiles,
  chartData,
  benefitTiles,
  getTileDisplayName
}) {
  return (
    <div className="md-benefit-tab">
      {/* Card: Summary + Bar Chart */}
      <div className="md-card">
        <h2>Benefit Buildings Summary</h2>
        <p>
          Below is a quick comparison of how many of each benefit-building subType exist
          in Nation {nationInfo.nationA.number} vs. Nation {nationInfo.nationB.number}.
        </p>
        {isLoadingTiles && <p>Loading benefit buildings...</p>}

        {!isLoadingTiles && chartData.length > 0 && (
          <div className="md-chart-wrap">
            <ResponsiveContainer>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="subType" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Legend />
                <Bar
                  dataKey="nationA"
                  fill="#8884d8"
                  name={`Nation ${nationInfo.nationA.number}`}
                />
                <Bar
                  dataKey="nationB"
                  fill="#82ca9d"
                  name={`Nation ${nationInfo.nationB.number}`}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* Table of totals */}
        {!isLoadingTiles && (
          <div className="md-table-wrap">
            <h4>Totals by SubType:</h4>
            <table className="md-summary-table">
              <thead>
                <tr>
                  <th>SubType</th>
                  <th>Nation {nationInfo.nationA.number}</th>
                  <th>Nation {nationInfo.nationB.number}</th>
                </tr>
              </thead>
              <tbody>
                {chartData.map((item) => (
                  <tr key={item.subType}>
                    <td>{item.subType}</td>
                    <td>{item.nationA}</td>
                    <td>{item.nationB}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Card: Detailed Tile Lists */}
      <div className="md-card">
        <h2>Benefit Tile Locations</h2>

        {isLoadingTiles && <p>Loading benefit buildings...</p>}

        {!isLoadingTiles && nationA && (
          <div className="md-tiles-container">
            {/* Nation A Benefit Tiles */}
            <div className="md-tile-column">
              <h3>Nation {nationInfo.nationA.number} Benefit Tiles</h3>
              {benefitTiles.nationA.length === 0 ? (
                <p>No benefit tiles found for Nation {nationInfo.nationA.number}.</p>
              ) : (
                <ul>
                  {benefitTiles.nationA.map((tile) => {
                    const displayName = getTileDisplayName(tile);
                    return (
                      <li key={tile._id}>
                        {displayName} — X: {tile.x}, Y: {tile.y}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>

            {/* Nation B Benefit Tiles */}
            <div className="md-tile-column">
              <h3>Nation {nationInfo.nationB.number} Benefit Tiles</h3>
              {!nationB ? (
                <p>Waiting for merger pairing announcement.</p>
              ) : benefitTiles.nationB.length === 0 ? (
                <p>No benefit tiles found for Nation {nationInfo.nationB.number}.</p>
              ) : (
                <ul>
                  {benefitTiles.nationB.map((tile) => {
                    const displayName = getTileDisplayName(tile);
                    return (
                      <li key={tile._id}>
                        {displayName} — X: {tile.x}, Y: {tile.y}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BenefitBuildingsTab;
